export const getFirstChar = (text: string) => {
  return text.slice(0, 1).toUpperCase();
};
